import { Button, ButtonProps } from 'antd';
import classNames from 'classnames';
import { omit } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import './index.less';

export type RevxButtonProps = ButtonProps & {
  gray?: boolean;
  brandBlue?: boolean;
  brandPurple?: boolean;
  brandGreen?: boolean;
  brandLightPurple?: boolean;
  brandOrange?: boolean;
  delay?: number;
};

const DEFAULT_DELAY = 800;

export const RevxButton = ({ className, ...props }: RevxButtonProps) => {
  const { onClick, delay } = props;
  const [disabled, setDisabled] = useState<boolean>(false);
  useEffect(() => {
    if (!disabled) {
      return;
    }
    const timer = setTimeout(() => {
      setDisabled(false);
    }, delay || DEFAULT_DELAY);
    return () => {
      clearTimeout(timer);
    };
  }, [disabled, delay]);
  const clickHandler = (e: React.MouseEvent<HTMLElement>): any => {
    if (disabled) {
      return;
    }
    setDisabled(true);
    return onClick?.(e);
  };

  return (
    <Button
      className={classNames('revx-button', className || '', {
        gray: props.gray,
        'brand-blue': props.brandBlue,
        'brand-purple': props.brandPurple,
        'brand-green': props.brandGreen,
        'brand-light-purple': props.brandLightPurple,
        'brand-orange': props.brandOrange,
      })}
      {...omit(
        props,
        'gray',
        'brandBlue',
        'brandPurple',
        'brandGreen',
        'brandLightPurple',
        'brandOrange',
        'onClick'
      )}
      onClick={clickHandler}
    ></Button>
  );
};
